module.exports = __webpack_public_path__ + "img/switch.811cee3c.svg";